import { BadgeM } from "@common/components/badge/BadgeM"
import { theme } from "@common/theme/theme"
import moment from "moment"
import React from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { capitalize } from "@data/utility/Utils"
import TextM from "@common/components/text/TextM"

export function LiveBadgeM(props) {
    const { liveSession, user = null, isPaymentBlocked = false } = props
    const { id, day_time: dayTime, live_room: liveRoom } = liveSession

    const slotMoment = dayTime ? moment(dayTime, "dddd HH:mm", "en") : null
    const slotMomentFormatted = slotMoment
        ? capitalize(slotMoment?.locale("fr")?.format("dddd HH:mm"))
        : null

    // Check if user is temporarilyAdded
    const isUserTemporarilyAdded = user
        ? (() => {
              const nextOccurrences = liveSession?.next_occurrences
              const allTemporaryAddedUsers = nextOccurrences
                  ?.reduce((acc, occ) => {
                      const temporaryAddedUsers =
                          occ?.added_users
                              ?.map((x) => ({
                                  ...x,
                                  temporarilyAdded: true,
                                  currentlyIn: liveSession?.users?.some(
                                      (u) => u.id === x.id
                                  ),
                              }))
                              .filter((u) => u?.class) ?? []
                      return [...acc, ...temporaryAddedUsers]
                  }, [])
                  .filter(
                      (userItem, index, self) =>
                          index === self.findIndex((u) => u.id === userItem.id)
                  )

              return allTemporaryAddedUsers?.some(
                  (tempUser) => tempUser.id === user.id
              )
          })()
        : false

    // Check if user is temporarilyRemoved
    const isUserTemporarilyRemoved = user
        ? (() => {
              const nextOccurrences = liveSession?.next_occurrences
              const allTemporaryRemovedUsers = nextOccurrences
                  ?.reduce((acc, occ) => {
                      const temporaryRemovedUsers =
                          occ?.removed_users
                              ?.map((x) => ({
                                  ...x,
                                  temporarilyRemoved: true,
                                  currentlyIn: liveSession?.users?.some(
                                      (u) => u.id === x.id
                                  ),
                              }))
                              .filter((u) => u?.class) ?? []
                      return [...acc, ...temporaryRemovedUsers]
                  }, [])
                  .filter(
                      (userItem, index, self) =>
                          index === self.findIndex((u) => u.id === userItem.id)
                  )

              return allTemporaryRemovedUsers?.some(
                  (tempUser) => tempUser.id === user.id
              )
          })()
        : false

    return (
        <View>
            <BadgeM
                key={id}
                style={{
                    backgroundColor: isPaymentBlocked
                        ? theme.colors.warningLight
                        : isUserTemporarilyAdded
                          ? theme.colors.primary + "11"
                          : isUserTemporarilyRemoved
                            ? theme.colors.greyAlt + "33"
                            : theme.colors.primaryLighter,
                    marginVertical: 3,
                    marginRight: 3,
                }}
                customContent={
                    <View
                        style={{ flexDirection: "row", alignItems: "center" }}
                    >
                        {isPaymentBlocked && (
                            <FontAwesome5
                                name="lock"
                                size={10}
                                color={theme.colors.warning}
                                style={{ marginRight: 5 }}
                            />
                        )}
                        {isUserTemporarilyAdded && !isPaymentBlocked && (
                            <FontAwesome5
                                name="clock"
                                size={12}
                                color={theme.colors.light}
                                style={{ marginRight: 5 }}
                            />
                        )}
                        {isUserTemporarilyRemoved && !isPaymentBlocked && (
                            <FontAwesome5
                                name="ban"
                                size={12}
                                color={theme.colors.greyAlt}
                                style={{ marginRight: 5 }}
                            />
                        )}
                        <TextM
                            fontSize={10}
                            fontWeight="Bold"
                            color={
                                isPaymentBlocked
                                    ? theme.colors.warning
                                    : isUserTemporarilyAdded
                                      ? theme.colors.light
                                      : isUserTemporarilyRemoved
                                        ? theme.colors.greyAlt
                                        : theme.colors.primary
                            }
                            style={
                                isUserTemporarilyRemoved
                                    ? { textDecorationLine: "line-through" }
                                    : {}
                            }
                        >{`${liveRoom?.name ?? ""} ${slotMomentFormatted}`}</TextM>
                    </View>
                }
                size={23}
            />
        </View>
    )
}
